<template>
  <el-cascader :value="value" :options="options" :props="props" @change="handleChange" style="width: 100%" clearable> </el-cascader>
</template>

<script>
export default {
  name: "AcePermissionSelector",
  model: {
    event: "change",
    prop: "value",
  },
  props: {
    value: [String, Array],
    appId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      props: {
        multiple: true,
        checkStrictly: true,
        emitPath: false,
        value: "code",
        label: "name",
      },
      options: [],
    };
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    handleChange(value) {
      // console.log(value)
      this.$emit("change", value);
    },
    optionsHandle(data) {
      //去子级
      function removeChildren(obj) {
        if (obj.children.length === 0) {
          delete obj.children;
        } else {
          obj.children.forEach((item) => {
            removeChildren(item);
          });
        }
      }
      data.forEach((item) => {
        removeChildren(item);
      });
      return data;
    },
    async getOptions() {
      const appId = this.appId || this.$cookie.get("appName");
      let options = await this.$http({
        url: this.$http.adornUrl("/sysAuths"),
        method: "get",
        params: this.$http.adornParams({
          appId: appId,
          name: "",
        }),
      });
      let { data } = options;
      if (data.code === 40000) {
        this.options = this.optionsHandle(data.list);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
